import { Sheets } from './Sheets';
import { SheetsStackProps } from './types';

export const SheetsStack = ({ sheets, className = '' }: SheetsStackProps) => {
  return (
    <div className={className}>
      {sheets.map((sheet, index) => (
        <Sheets {...sheet} key={index} isFirstItem={index === 0}>
          {sheet.children}
        </Sheets>
      ))}
    </div>
  );
};
